import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";

export const getFormMetadataFields = createAsyncThunk(
  "metadataField/getByForm",
  async (formId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.METADATA_FIELD.GET_BY_FORM}/${formId}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getDocumentMetadataFields = createAsyncThunk(
  "metadataField/getByDocument",
  async (documentId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.METADATA_FIELD.GET_BY_DOCUMENT}/${documentId}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const createMetadataField = createAsyncThunk(
  "metadataField/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        API_URL.METADATA_FIELD.CREATE,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const updateMetadataField = createAsyncThunk(
  "metadataField/update",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await axios.put(
        API_URL.METADATA_FIELD.UPDATE,
        payload
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const deleteMetadataField = createAsyncThunk(
  "metadataField/delete",
  async (fieldId, { rejectWithValue }) => {
    try {
      const { data } = await axios.delete(
        `${API_URL.METADATA_FIELD.DELETE}/${fieldId}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const setReferenceDateField = createAsyncThunk(
  "metadataField/setReferenceDate",
  async ({ entityId, fieldId, isForm }, { rejectWithValue }) => {
    try {
      const baseUrl = isForm
        ? API_URL.METADATA_FIELD.SET_REFERENCE_DATE_FORM
        : API_URL.METADATA_FIELD.SET_REFERENCE_DATE_DOCUMENT;
      const { data } = await axios.put(`${baseUrl}/${entityId}/${fieldId}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const clearReferenceDateField = createAsyncThunk(
  "metadataField/clearReferenceDate",
  async ({ entityId, isForm }, { rejectWithValue }) => {
    try {
      const baseUrl = isForm
        ? API_URL.METADATA_FIELD.SET_REFERENCE_DATE_FORM
        : API_URL.METADATA_FIELD.SET_REFERENCE_DATE_DOCUMENT;
      const { data } = await axios.delete(`${baseUrl}/${entityId}`);
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const metadataFieldSlice = createSlice({
  name: "metadataField",
  initialState: {
    fields: [],
    loading: false,
  },
  reducers: {
    resetMetadataFields(state) {
      state.fields = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFormMetadataFields.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFormMetadataFields.fulfilled, (state, action) => {
        state.fields = action.payload;
        state.loading = false;
      })
      .addCase(getFormMetadataFields.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getDocumentMetadataFields.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDocumentMetadataFields.fulfilled, (state, action) => {
        state.fields = action.payload;
        state.loading = false;
      })
      .addCase(getDocumentMetadataFields.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { resetMetadataFields } = metadataFieldSlice.actions;
export default metadataFieldSlice.reducer;
